import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { RouterModule } from '@angular/router';
import { MenuComponent } from './components/menu/menu.component';
import { GoTopComponent } from './components/gotop/gotop.component';
import { SharedModule } from "../shared/shared.module";



@NgModule({
  declarations: [
    LayoutComponent,
    MenuComponent,
    GoTopComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
})
export class LayoutModule { }
